import React, {useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import classNames from "classnames";
import {RootState} from "../../../reducers";
import {getStoreState} from "../../services/Store/reducer";
import NavbarMenus from "./NavbarMenus";
import NavbarUser from "./NavbarUser";
import {ReactComponent as BarsIco} from "../../../images/icons/bars.svg";
import Drawer from "./Drawer";
import {selectLocale} from "../../services/Session/reducer";
import NavbarHours from "./NavbarHours";
import StoreUtils from "../../services/Store/StoreUtils";
import NavbarPlaces from "./NavbarPlaces";
import AppConfig from "../../services/AppConfig";
import NavbarVouchers from "./NavbarVouchers";

interface OwnProps {
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

function Navbar(props: Props) {
    const [pagesCollapse, setPagesCollapse] = useState(false);
    const [drawer, setDrawer] = useState(false);
    const config = props.store_state.config;
    const {t} = useTranslation();

    if (!config) return null;

    const configLayout = config.layout;
    if (!configLayout) return null;

    const anyMenuLinks = configLayout?.links?.some(x => x.type === "MENU");

    const renderLogoView = () => {
        if (configLayout?.image_link) {
            return (
                <img alt={t("common.word.location_logo")} src={configLayout.image_link.default}/>
            )
        }
        return (
            <div className={"logo-text"}>
                {config?.name}
            </div>
        );
    }



    if (AppConfig.isNativeMobile()) return null;

    const handleOpenDrawer = (event:  React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setDrawer(!drawer);
        event.currentTarget.blur();
    }

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light sticky-top">
                <div className="navbar-brand-container">
                    <Link to="/" className="navbar-brand">
                        {renderLogoView()}
                    </Link>
                    {StoreUtils.isMultistore(props.store_state.default_config) ? (
                        <NavbarPlaces config={props.store_state.config}/>
                    ) : null}
                    <div className="navbar-options">
                        <NavbarHours/>
                        <NavbarVouchers/>
                        <NavbarUser/>
                        {/*<NavbarLanguages languages={config.languages} locale={props.locale}/>*/}
                        <button className="btn-icon navbar-toggler" type="button" aria-label={t("modules.navbar.field.drawer.title")}
                                onClick={handleOpenDrawer}>
                            <BarsIco aria-hidden="true" />
                        </button>
                    </div>
                    {(anyMenuLinks) && (
                        <div className={classNames(`navbar-menus collapse navbar-collapse`, {
                            'show': pagesCollapse
                        })} id="navbarNav">
                            {anyMenuLinks && (
                                <NavbarMenus links={configLayout?.links}/>
                            )}
                        </div>
                    )}
                </div>
            </nav>
            <Drawer config={props.store_state.config} onHide={() => setDrawer(false)} show={drawer}/>
        </>
    )
}


const mapStateToProps = (state: RootState) => ({
    store_state: getStoreState(state.config),
    locale: selectLocale(state.session)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(Navbar));